import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, setAdminToken } from "@/lib/api";
import { LOGO_URL } from "@/lib/constants";
import { toast } from "sonner";
import { Lock, Loader2, ArrowLeft, Eye, EyeOff } from "lucide-react";
import { Link } from "react-router-dom";

const AdminLogin = () => {
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { password: password.trim() });
      setAdminToken(res.data.token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-spark-teal-deep text-white flex flex-col grain-overlay relative" data-testid="admin-login-page">
      <Link to="/" className="absolute top-6 left-6 flex items-center gap-2 label-mono text-slate-400 hover:text-spark-yellow z-10" data-testid="admin-login-back">
        <ArrowLeft className="size-4" /> Back to site
      </Link>
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md relative z-10">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="Spark Scooter Repairs" className="size-20 mx-auto mb-4 rounded-full border-4 border-spark-yellow" />
            <p className="label-mono text-spark-yellow mb-2">Workshop control room</p>
            <h1 className="font-display uppercase tracking-tight text-4xl sm:text-5xl font-bold">Admin Login</h1>
          </div>
          <form onSubmit={onSubmit} className="bg-white text-spark-ink rounded-md p-6 sm:p-8 space-y-5">
            <div>
              <label className="label-mono mb-2 inline-block">Password</label>
              <div className="relative">
                <Lock className="size-4 absolute left-3 top-1/2 -translate-y-1/2 text-spark-slate" />
                <input
                  type={showPw ? "text" : "password"}
                  className="input-style pl-10 pr-10"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  autoFocus
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck={false}
                  autoComplete="current-password"
                  data-testid="admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPw((v) => !v)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-spark-slate hover:text-spark-teal"
                  aria-label={showPw ? "Hide password" : "Show password"}
                  data-testid="admin-password-toggle"
                >
                  {showPw ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading || !password} className="btn-primary w-full" data-testid="admin-login-btn">
              {loading ? <Loader2 className="size-4 animate-spin" /> : <Lock className="size-4" />} Sign In
            </button>
          </form>
          <p className="text-center text-xs text-slate-500 mt-6">Authorised personnel only.</p>
        </div>
      </main>
    </div>
  );
};

export default AdminLogin;
